import {Model} from './model';
import {Unserializer} from './serialization';

export class PaymentHistory implements Model {
  paymentHistoryId: number;
  invoiceId: number;
  userId?: number;
  sum?: number;
  payment: boolean;
  changed: Date;
  description: string;
  externalId?: string;
  created: Date;

  static copy(oldObj: PaymentHistory): PaymentHistory {
    const newObj = new PaymentHistory();
    newObj.paymentHistoryId = oldObj.paymentHistoryId;
    newObj.invoiceId = oldObj.invoiceId;
    newObj.userId = oldObj.userId;
    newObj.sum = oldObj.sum;
    newObj.payment = oldObj.payment;
    newObj.changed = Unserializer.date(oldObj.changed);
    newObj.description = oldObj.description;
    newObj.externalId = oldObj.externalId;
    newObj.created = Unserializer.date(oldObj.created);
    return newObj;
  }

  public getPrimaryKey(): number {
    return this.paymentHistoryId;
  }

  isNew(): boolean {
    return isNaN(this.paymentHistoryId);
  }

  clone(): PaymentHistory {
    return PaymentHistory.copy(this);
  }
}
